import { render, staticRenderFns } from "./ContractorIndex.vue?vue&type=template&id=2353dbf9&"
import script from "./ContractorIndex.vue?vue&type=script&lang=js&"
export * from "./ContractorIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports